import { createDecorator } from '../../instantiation/common/instantiation.js';
export class Progress {
  constructor(callback) {
    this.callback = callback;
  }
  report(item) {
    this._value = item;
    this.callback(this._value);
  }
}
Progress.None = Object.freeze({
  report() {}
});
export const IEditorProgressService = createDecorator('editorProgressService');